import { render, staticRenderFns } from "./Deleted.vue?vue&type=template&id=06ca1348"
import script from "./Deleted.vue?vue&type=script&lang=js"
export * from "./Deleted.vue?vue&type=script&lang=js"
import style0 from "./Deleted.vue?vue&type=style&index=0&id=06ca1348&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports